import { Exchange } from 'icons';
import { FormattedMessage } from 'localization';

import {
  EnumDeskRoutes,
  EnumReturnsAndExchangesRoutes,
  EnumSettingRoutes,
  EnumTrackingRoutes,
} from '../../../constants';
import { SettingsSidebarMenuItem } from '../AdminSettingsSidebar';

const returnsAndExchangesSection: SettingsSidebarMenuItem = {
  icon: <Exchange width={18} height={18} />,

  data: [
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.returnsAndExchanges}/${EnumTrackingRoutes.portalStyle}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="desk-app.settings.sidebar.portal-style" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.returnsAndExchanges}/${EnumReturnsAndExchangesRoutes.returnRules}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="settings.rules.tabs.return" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.returnsAndExchanges}/${EnumReturnsAndExchangesRoutes.returnReasons}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="analytics.ind.return-reasons" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.returnsAndExchanges}/${EnumReturnsAndExchangesRoutes.returnInstructions}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="settings.portal.instructions.return-instructions" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.returnsAndExchanges}/${EnumReturnsAndExchangesRoutes.returnTranslations}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="desk-app.settings.sidebar.translations" />
        </div>
      ),
    },
  ],
  translationKey: 'dashboard.returnsExchanges',
};

export { returnsAndExchangesSection };
